/* Buy now, size chart shortcut and compare/wishlist press-state for the PDP product actions block. */
(function () {
  function getForm(button) {
    var formId = button.getAttribute('data-buy-now-form');
    return formId ? document.getElementById(formId) : button.closest('form');
  }

  function showError(form, message) {
    var container = form.querySelector('[data-cart-errors-container]');
    var messageEl = form.querySelector('[data-cart-error-message]');

    if (messageEl) messageEl.textContent = message;
    if (container) container.classList.add('is-visible');
  }

  function hideError(form) {
    var container = form.querySelector('[data-cart-errors-container]');
    if (container) container.classList.remove('is-visible');
  }

  function initBuyNowButtons() {
    document.querySelectorAll('[data-buy-now]:not([data-buy-now-bound])').forEach(function (button) {
      button.setAttribute('data-buy-now-bound', 'true');

      button.addEventListener('click', function () {
        if (button.disabled) return;

        var form = getForm(button);
        if (!form) return;

        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
          form.reportValidity();
          return;
        }

        hideError(form);
        button.classList.add('is-loading');
        button.disabled = true;

        var formData = new FormData(form);

        fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              showError(form, response.description || response.message || button.getAttribute('data-error-message'));
              button.classList.remove('is-loading');
              button.disabled = false;
              return;
            }

            window.location.href = window.theme.routes.root + 'checkout';
          })
          .catch(function () {
            showError(form, button.getAttribute('data-error-message'));
            button.classList.remove('is-loading');
            button.disabled = false;
          });
      });
    });
  }

  function initSizeChartButtons() {
    document.querySelectorAll('[data-size-chart-trigger]:not([data-size-chart-bound])').forEach(function (button) {
      button.setAttribute('data-size-chart-bound', 'true');

      button.addEventListener('click', function () {
        var scope = button.closest('[data-form-wrapper]') || document;
        var trigger = scope.querySelector('[data-size-chart-open-trigger]') || document.querySelector('[data-size-chart-open-trigger]');

        if (trigger) trigger.click();
      });
    });
  }

  function initPressToggles(selector) {
    document.querySelectorAll(selector + ':not([data-press-bound])').forEach(function (button) {
      button.setAttribute('data-press-bound', 'true');

      button.addEventListener('click', function () {
        var pressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!pressed));
        button.classList.toggle('is-active', !pressed);
      });
    });
  }

  /**
   * The Swym wishlist app owns the real add/remove-from-wishlist logic through its own
   * hidden button (#swym-custom-pdp-button .swym-icon-text). Our button is just a
   * proxy: clicking it clicks the Swym button, and its filled/unfilled state always
   * mirrors the Swym button's aria-pressed state (never toggled locally).
   */
  function getSwymButton() {
    return document.querySelector('#swym-custom-pdp-button .swym-icon-text');
  }

  function syncWishlistState() {
    var swymButton = getSwymButton();
    if (!swymButton) return;

    var pressed = swymButton.getAttribute('aria-pressed') === 'true';

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(pressed));
      button.classList.toggle('is-active', pressed);
    });
  }

  function watchSwymButton() {
    var container = document.getElementById('swym-custom-pdp-button');

    if (!container) {
      var appearObserver = new MutationObserver(function () {
        var appeared = document.getElementById('swym-custom-pdp-button');
        if (!appeared) return;

        appearObserver.disconnect();
        syncWishlistState();
        new MutationObserver(syncWishlistState).observe(appeared, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      });

      appearObserver.observe(document.body, {childList: true, subtree: true});
      return;
    }

    syncWishlistState();
    new MutationObserver(syncWishlistState).observe(container, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  function initWishlistButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]:not([data-wishlist-bound])');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.setAttribute('data-wishlist-bound', 'true');

      button.addEventListener('click', function () {
        var swymButton = getSwymButton();
        if (!swymButton || swymButton.getAttribute('aria-busy') === 'true') return;
        swymButton.click();
      });
    });

    watchSwymButton();
  }

  function init() {
    initBuyNowButtons();
    initSizeChartButtons();
    initPressToggles('[data-compare-toggle]');
    initWishlistButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
